import {
    BODY_MD_MD_STYLES,
    BODY_REGULAR_STYLES,
    BODY_SM_SM_MEDIUM_STYLES,
    BODY_SM_SM_STYLES,
    HEADING_SM_STYLES,
} from '@constants/text.ts';
import styled from 'styled-components';

export const ContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;

    .ant-alert-message {
        margin-top: 2px;
    }
`;

export const PhotosWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
    margin-top: 24px;
    margin-bottom: 8px;
`;

export const ImageLabel = styled.div`
    ${BODY_SM_SM_MEDIUM_STYLES};
    color: var(--neutral-350, #b4b8bf);
`;

export const UploadAreaHintText = styled.div`
    ${BODY_MD_MD_STYLES};
    color: var(--colors-text-body, #50566e);
    margin-top: 16px;
`;

export const UploadStateInfo = styled.div`
    color: var(--colors-text-body, #50566e);
    ${BODY_SM_SM_STYLES};
`;

export const UploadAreaFile = styled.div`
    ${BODY_REGULAR_STYLES};
    color: var(--colors-text-information, #2171c6);
`;

export const Title = styled.div`
    ${HEADING_SM_STYLES};
`;
